import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'


const state = {
    server_data: [],
    documentFileSelected: []
}

const getters = {
    notifications: function (state) {
        let data = state.server_data.sort((a, b) => {
            return new Date(b.created) - new Date(a.created);
        });
        return data;
    },
    notificationByWorkspace: (state) => (id) => {
        let retval = state.server_data.sort((a, b) => {
            return new Date(b.created) - new Date(a.created);
        });
        return retval.filter(item => item.workspace == id)
    },
    documentFileSelected: (state) => state.documentFileSelected
}

const mutations = {
    initialize(state) {
        state.server_data = [];
        state.documentFileSelected = [];
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.server_data = _.map(state.server_data, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.server_data = _.concat(state.server_data, payload)
        state.server_data = _.without(state.server_data, null, undefined)
    },
    setFileData(state, payload) {
        state.documentFileSelected = payload
    }
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('getNotifications')
            .then(() => {
            })
            .catch(() => { })
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    markRead({ state, dispatch, commit }, payload) {
        let url = `/notifications/true/${payload._id}`;
        if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'No arguments provided' })
        return api.patch(url, { encrypt: { data: payload } })
            .then(data => {
                dispatch('getNotifications')
                    .then(() => {
                    })
                    .catch(() => { })
                commit('merge', data.data.encrypt.data)
            })
            .catch(err => {
                console.error(`Error during investment patch: ${err}`)
                return Promise.reject(err)
            })
    },
    markUnRead({ state, dispatch, commit }, payload) {
        let url = `/notifications/false/${payload._id}`;
        if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'No arguments provided' })
        return api.patch(url, { encrypt: { data: payload } })
            .then(data => {
                dispatch('getNotifications')
                    .then(() => {
                    })
                    .catch(() => { })
                commit('merge', data.data.encrypt.data)
            })
            .catch(err => {
                console.error(`Error during investment patch: ${err}`)
                return Promise.reject(err)
            })
    },
    markAllRead({ state, dispatch, commit }, payload) {
        let url = `/markAll/notifications/read`;
        if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'No arguments provided' })
        return api.patch(url, { encrypt: { data: payload.id } })
            .then(data => {
                dispatch('getNotifications')
                    .then(() => {
                    })
                    .catch(() => { })
                //commit('merge', data.data.encrypt.data)
            })
            .catch(err => {
                console.error(`Error during investment patch: ${err}`)
                return Promise.reject(err)
            })
    },
    getNotifications({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.id) {
                let url = `/notification/${fiifi.id}`;
                return api.get(url)
                    .then(data => {
                        commit('merge', data.data.encrypt.data)
                        return Promise.resolve(data.data.encrypt.data)
                    })
                    .catch(err => {
                        console.error(`Error during notifications fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostGenericNotification({ commit, dispatch }, payload) {
        let url = `/generic/notifications`;
        return api.post(url, { encrypt: { data: payload } })
            .then(data => {
                return Promise.resolve(data.data.encrypt)
            })
            .catch(err => {
                console.error(`Error during notifications fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    apiDiligenceCollaboratorReceipt({ commit, dispatch, rootGetters }, notificationPaylod) {
        let type = notificationPaylod.type;
        let diligenceData = notificationPaylod.diligenceData
        let self = this;
        let userName = rootGetters["user/user"];
        let userNameString =
            userName.firstName != userName.lastName
                ? `${userName.firstName} ${userName.lastName} `
                : userName.lastName;
        let payload = [];
        let getAllUsers = rootGetters["team/getAllUsers"];
        let teams = getAllUsers ? JSON.parse(JSON.stringify(getAllUsers)) : [];
        let emails = [];
        teams.map((item) => {
            if (
                item.account &&
                item.account._id != diligenceData.account_id
            ) {
                let payloadObj = {};
                payloadObj.account = item.account._id;
                payloadObj.workspace = diligenceData.workspace_id;
                payloadObj.title = diligenceData.name;
                payloadObj.link = `/${item.account._id}/${diligenceData.workspace_id}/companyProfile/${diligenceData.ucid}`;
                payloadObj.type = "Notification";
                payloadObj.notified_by = diligenceData.account_id;
                payloadObj.organization = diligenceData.organization;
                if (type == "round") {
                    payloadObj.body = `${userNameString} has changed ${diligenceData.name} round to ${diligenceData.stage}`;
                } else if (
                    type == "stage" &&
                    diligenceData.stage.toLowerCase() == "rejected"
                ) {
                    payloadObj.body = `${userNameString} has archived the ${diligenceData.name} deal`;
                } else if (
                    type == "stage" &&
                    diligenceData.stage.toLowerCase() != "rejected"
                ) {
                    payloadObj.body = `${userNameString} has changed ${diligenceData.name} stage to ${diligenceData.stage}`;
                } else if (type == "suggestions") {
                    payloadObj.body = `${userNameString} has added ${diligenceData.name} deal`;
                }
                if (item.account.google && item.account.google.email)
                    emails.push(item.account.google.email);
                else if (item.account.facebook && item.account.facebook.email)
                    emails.push(item.account.facebook.email);
                else if (item.account.linkedin && item.account.linkedin.email)
                    emails.push(item.account.linkedin.email);
                else if (item.account.cognito && item.account.cognito.email)
                    emails.push(item.account.cognito.email);
                else if (item.account.ltse && item.account.ltse.email)
                    emails.push(item.account.ltse.email);
                payload.push(payloadObj);
            }
        });
        payload.map((item, index) => {
            dispatch("apiPostGenericNotification", item)
                .then((notificationData) => {
                    if (index == payload.length - 1) {
                        let emailPayload = {
                            emails,
                            subject: `${payload[0].title} Deal update`,
                            body: payload[0].body,
                        };
                        api
                            .post("/generic/send/email", {
                                encrypt: { data: emailPayload },
                            })
                            .then((response) => { })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                })
                .catch((err) => { });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}